import {HandlerEnum} from './enum';
import {
  updateHeaderBgColor,
  updatePageTheme,
  updateSidebarBgColor,
  updateSystemTheme
} from '@/logics/theme/updateBackground';
import {updateColorWeak} from '@/logics/theme/updateColorWeak';
import {updateGrayMode} from '@/logics/theme/updateGrayMode';

import {useAppStore} from '@/store/modules/app';
import {ProjectConfig} from '/#/config';
import {changeTheme} from '@/logics/theme';
import {updateDarkTheme} from '@/logics/theme/dark';
import {useRootSetting} from '@/hooks/setting/useRootSetting';

export function baseHandler(event: HandlerEnum, value: any) {
  const appStore = useAppStore();
  const config = handler(event, value);
  appStore.setProjectConfig(config);
  if (event === HandlerEnum.CHANGE_THEME) {
    updateHeaderBgColor();
    updateSidebarBgColor();
  }
}

export function handler(event: HandlerEnum, value: any): DeepPartial<ProjectConfig> {
  const appStore = useAppStore();

  const { getThemeColor, getDarkMode } = useRootSetting();
  switch (event) {
    case HandlerEnum.CHANGE_LAYOUT:
      const { mode, type, split } = value;
      // split 显式传入时才更新（含 false）；undefined 表示保持原值
      const splitOpt = split === undefined ? {} : { split };

      return {
        menuSetting: {
          mode,
          type,
          collapsed: false,
          show: true,
          hidden: false,
          ...splitOpt,
        },
      };

    case HandlerEnum.CHANGE_THEME_COLOR:
      updateSystemTheme(value);
      if (getThemeColor.value === value) {
        return {};
      }
      changeTheme(value);
      return { themeColor: value };

    case HandlerEnum.CHANGE_THEME:
      if (getDarkMode.value === value) {
        return {};
      }
      updateDarkTheme(value);

      return {};

    case HandlerEnum.MENU_HAS_DRAG:
      return { menuSetting: { canDrag: value } };
    // 菜单收藏
    case HandlerEnum.MENU_COLLECT:
      return { menuSetting: { menuCollect: value } };
    //  菜单查询
    case HandlerEnum.MENU_QUERY:
      return { menuSetting: { menuQuery: value } };
    //  菜单查询
    case HandlerEnum.MENU_BG_IMG:
      return { menuSetting: { menuBgImg: value } };
    //  菜单查询
    case HandlerEnum.MENU_BG_IMG_RED:
      return { menuSetting: { menuBgImgRed: value } };
    //现场菜单手风琴
    case HandlerEnum.MENU_ACCORDION:
      return { menuSetting: { accordion: value } };
    //是否显示应用菜单
    case HandlerEnum.NOT_SHOW_APP_MENU:
      return { notShowAppMenuFlag: value };

    case HandlerEnum.MENU_TRIGGER:
      return { menuSetting: { trigger: value } };

    case HandlerEnum.MENU_TOP_ALIGN:
      return { menuSetting: { topMenuAlign: value } };

    //背景颜色
    case HandlerEnum.BACK_GROUND_COLOR_THEME:
      updatePageTheme(value);
      return { pageBgColor: value };

    //背景显示类型
    case HandlerEnum.BACK_GROUND_SHOW_TYPE:
      return { pageBgShowType: value };
    //背景图片地址
    case HandlerEnum.BACK_GROUND_IMG_SRC:
      return { pageBgImgSrc: value };
    //背景模糊度
    case HandlerEnum.BACK_FILTER_VAL:
      return { pageBgFilterVal: value };
    //背景蒙层
    case HandlerEnum.BACK_OPACITY_VAL:
      return { pageBgOpAcityVal: value };
    //背景蒙层颜色
    case HandlerEnum.BACK_MASK_COLOR:
      return { pageMaskColor: value };

    //  卡片空间
    case HandlerEnum.USE_DEF_LAYOUT:
      return { userDefLayout: value };

    //  快捷菜单
    case HandlerEnum.QUICK_MENU_SHOW:
      return { quickMenuFlag: value };
    //  菜单互斥
    case HandlerEnum.MENU_OPEN_MORE:
      return { menuOpenMore: value };
    //菜单宽度
    case HandlerEnum.BASE_BORDER_RADUIS_SET:
      return { baseBorderRaduis: value };

    case HandlerEnum.BASE_SPACE:
      return { baseSpace: value };

    case HandlerEnum.BASE_FONT_SIZE_SET:
      return { baseFontSize: value };

    case HandlerEnum.MENU_WIDTH_LEFT:
      return { leftMenuWidth: value };

    case HandlerEnum.MENU_COLLAPSED:
      return { menuSetting: { collapsed: value } };

    case HandlerEnum.MENU_WIDTH:
      return { menuSetting: { menuWidth: value } };

    case HandlerEnum.MENU_SHOW_SIDEBAR:
      return { menuSetting: { show: value } };

    case HandlerEnum.MENU_COLLAPSED_SHOW_TITLE:
      return { menuSetting: { collapsedShowTitle: value } };

    case HandlerEnum.MENU_THEME:
      updateSidebarBgColor(value);
      return { menuSetting: { bgColor: value } };

    case HandlerEnum.MENU_EXTEND_THEME:
      return { menuSetting: { menuExtendTheme: value } };

    case HandlerEnum.MENU_SPLIT:
      return { menuSetting: { split: value } };

    case HandlerEnum.MENU_CLOSE_MIX_SIDEBAR_ON_CHANGE:
      return { menuSetting: { closeMixSidebarOnChange: value } };

    case HandlerEnum.MENU_FIXED:
      return { menuSetting: { fixed: value } };

    case HandlerEnum.MENU_TRIGGER_MIX_SIDEBAR:
      return { menuSetting: { mixSideTrigger: value } };

    case HandlerEnum.MENU_FIXED_MIX_SIDEBAR:
      return { menuSetting: { mixSideFixed: value } };

    // ============transition==================
    case HandlerEnum.OPEN_PAGE_LOADING:
      appStore.setPageLoading(false);
      return { transitionSetting: { openPageLoading: value } };

    case HandlerEnum.ROUTER_TRANSITION:
      return { transitionSetting: { basicTransition: value } };

    case HandlerEnum.OPEN_ROUTE_TRANSITION:
      return { transitionSetting: { enable: value } };

    case HandlerEnum.OPEN_PROGRESS:
      return { transitionSetting: { openNProgress: value } };
    // ============root==================

    case HandlerEnum.LOCK_TIME:
      return { lockTime: value };

    case HandlerEnum.FULL_CONTENT:
      return { fullContent: value };

    case HandlerEnum.CONTENT_MODE:
      return { contentMode: value };

    case HandlerEnum.SHOW_BREADCRUMB:
      return { showBreadCrumb: value };

    case HandlerEnum.SHOW_BREADCRUMB_ICON:
      return { showBreadCrumbIcon: value };

    case HandlerEnum.GRAY_MODE:
      updateGrayMode(value);
      return { grayMode: value };

    case HandlerEnum.SHOW_FOOTER:
      return { showFooter: value };

    case HandlerEnum.COLOR_WEAK:
      updateColorWeak(value);
      return { colorWeak: value };

    case HandlerEnum.SHOW_LOGO:
      return { showLogo: value };

    // ============tabs==================
    case HandlerEnum.TABS_SHOW_QUICK:
      return { multiTabsSetting: { showQuick: value } };

    case HandlerEnum.TABS_THEME:
      return { multiTabsSetting: { theme: value } };

    case HandlerEnum.TABS_SHOW:
      return { multiTabsSetting: { show: value } };

    case HandlerEnum.TABS_SHOW_REDO:
      return { multiTabsSetting: { showRedo: value } };

    case HandlerEnum.TABS_SHOW_FOLD:
      return { multiTabsSetting: { showFold: value } };

    // ============header==================
    case HandlerEnum.HEADER_THEME:
      updateHeaderBgColor(value);
      return { headerSetting: { bgColor: value } };
    case HandlerEnum.HEADER_ICON_THEME:
      return { headerSetting: { iconColor: value } };
    //显示系统标题
    case HandlerEnum.HEADER_SYSTEM_TITLE:
      return { headerSetting: { showSystemTitle: value } };

    case HandlerEnum.HEADER_SEARCH:
      return { headerSetting: { showSearch: value } };
    //移动下载
    case HandlerEnum.HEADER_SHOW_APP:
      return { headerSetting: { showApp: value } };
    //  动态呼叫
    case HandlerEnum.HEADER_CALLING_SHOW:
      return { headerSetting: { showCalling: value } };

    case HandlerEnum.HEADER_RIGHT_TOOLS_EDITOR:
      return { headerSetting: { editoring: value } };

    case HandlerEnum.HEADER_NOTICE:
      return { headerSetting: { showNotice: value } };

    case HandlerEnum.HEADER_BIG_SCREEN:
      return { headerSetting: { showFullScreen: value } };

    case HandlerEnum.HEADER_HELP_ICON_SCREEN:
      return { headerSetting: { showHelp: value } };

    case HandlerEnum.HEADER_FIXED:
      return { headerSetting: { fixed: value } };

    case HandlerEnum.HEADER_SHOW:
      return { headerSetting: { show: value } };

    case HandlerEnum.HEADER_KEEP_ALIVE:
      return { openKeepAlive: value };

    default:
      return {};
  }
}
